<template>
  <div class="modal-card" :style="{minHeight: 60 + 'vh'}">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Upload Contract
      </p>
      {{ distributor.id }}- {{ distributor.name }}
      <button
        type="button"
        class="delete"
        @click="$emit('on-close')"
      />
    </header>
    <section class="modal-card-body">
      <section class="mt-2">
        <div
          v-for="(file, index) in files"
          :key="index + 'legalfile'"
          :style="{
            backgroundColor: 'white',
            width: 'fit-content',
            borderRadius: '25px'
          }"
        >
          <b-field grouped>
            <b-field class="mt-2 ml-2">
              {{ file.fileName }}
            </b-field>
            <b-button
              class="left-right"
              type="is-ghost"
              icon-left="download"
              :style="{'display': 'block', 'color': 'black' }"
              @click="() => { downloadFile(file) }"
            />
          </b-field>
        </div>
        <b-field style="margin-top: 10px;">
          <b-upload
            v-model="dropFiles"
            drag-drop
            @input="handleFileUpload"
          >
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon
                    icon="upload"
                    size="is-large"
                  />
                </p>
                <p>Drop your file here or click to upload</p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <div class="tags">
          <span
            v-for="(file, index) in dropFiles"
            :key="index"
            class="tag is-primary"
          >
            {{ file.name }}
            <button
              class="delete is-small"
              type="button"
              @click="deleteDropFile(index)"
            />
          </span>
        </div>
      </section>
    </section>

    <footer class="modal-card-foot">
      <div class="buttons">
        <b-button type="is-primary" @click="submit">
          Submit
        </b-button>
        <b-button @click="$emit('on-close')">
          Cancel
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import Distribution from '../../services/v2/distribution'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'

export default {
  props: {
    distributor: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dropFiles: [],
      files: []
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted () {
    this.getData()
  },
  methods: {
    handleFileUpload (file) {
      this.dropFiles = file ? [file] : []
    },
    deleteDropFile (index) {
      this.dropFiles.splice(index, 1)
    },
    async downloadFile (file) {
      const result = await Distribution.downloadLegal(file.distributorCode, file.fileName)
      saveAs(result.data, `${file.fileName}`)
    },
    async getData () {
      this.files = await Distribution.getLegal({ distributorCode: this.distributor.id })
    },
    async submit () {
      if (this.dropFiles.length === 0) {
        this.$buefy.toast.open({
          message: 'Please upload a file or check "Nothing to declare".',
          type: 'is-danger'
        })
        return
      }

      const formData = new FormData()
      formData.append('file', this.dropFiles[0])
      formData.append('uploadedBy', this.user.displayName)

      try {
        await Distribution.uploadLegal(this.distributor.id, formData)

        this.$buefy.toast.open({ message: 'Upload successfully', type: 'is-primary', duration: 4000 })

        this.$emit('on-close')
      } catch (e) {
        this.$buefy.toast.open({ message: e.message || e, type: 'is-danger', duration: 4000 })
      }
    }
  }
}
</script>
